import script from "./property-owner-details-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./property-owner-details-page.vue?vue&type=script&setup=true&lang=ts"

import "./property-owner-details-page.vue?vue&type=style&index=0&id=12f6935c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12f6935c"]])

export default __exports__